import { ADD_DASHBOARD_SUMMARY, DASHBOARD_START_LOADER, DASHBOARD_STOP_LOADER, DASHBOARD_ERROR, DASHBOARD_HIDE_ERROR, } from "@frameworks/web/redux/interfaces/Reports/iDashboardSummary";
const init = {
    data: [],
    summary: {
        totalPnl: "0",
        totalPnlChangePercent: "0",
        realisedPnl: "0",
        realisedPnlChangePercent: "0",
        unrealisedPnl: "0",
        unrealisedPnlChangePercent: "0",
        closePriceDate: "",
        totalMarketValue: "",
        totalClosingCostValue: "",
        totalSellCostValue: "",
        editableCount: 0,
        totalInvestment: "0",
        totalSellValue: "0",
        daysPnLChange: "0",
        daysPnLChangePercent: "0",
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    pnlDataFlags: {
        isBodEnabled: false,
        bodProcessInfoMessage: ""
    }
};
const dashboardSummary = (state = init, actions) => {
    var _a;
    switch (actions.type) {
        case ADD_DASHBOARD_SUMMARY:
            return Object.assign(Object.assign({}, state), { data: actions.payload.data, summary: actions.payload.summary, pnlDataFlags: (_a = actions.payload) === null || _a === void 0 ? void 0 : _a.pnlDataFlags });
        case DASHBOARD_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case DASHBOARD_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        case DASHBOARD_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: actions.payload.errorData });
        case DASHBOARD_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: { error: null, isOpen: false } });
        default:
            return Object.assign({}, state);
    }
};
export default dashboardSummary;
